import { useCallback } from 'react';
import { CheckpointQueueAccessType } from '../../../domain/models/CheckpointQueueAccessType';
import { useStores } from '../../../../app/root/domain/stores/useStores';
import {
	EVENT_ACTION_SECURITY_WAITING_TIMES_FILTER_CHANGE,
	EVENT_CATEGORY_SECURITY_WAITING_TIMES,
	trackCustomEvent,
} from '../../../../shared/analytics';

export function useAccessTypeSelectHandler() {
	const { checkpointQueueListStore: store } = useStores();

	return useCallback(
		(accessType: CheckpointQueueAccessType) => {
			store.setAccessType(accessType);
			trackFilterChange(accessType);
		},
		[store],
	);
}

function trackFilterChange(accessType: CheckpointQueueAccessType) {
	trackCustomEvent({
		category: EVENT_CATEGORY_SECURITY_WAITING_TIMES,
		action: EVENT_ACTION_SECURITY_WAITING_TIMES_FILTER_CHANGE,
		label: accessType,
	});
}
